<template>
  <q-layout view="lHh Lpr lFf" class="bg-grey-2">
    <q-header unelevated class="bg-white text-black">
      <q-toolbar>
        <q-btn
          flat
          dense
          round
          @click="leftDrawerOpen = !leftDrawerOpen"
          aria-label="Menu"
          icon="menu"
        />

        <q-toolbar-title> Quasar App </q-toolbar-title>

        <div>Quasar v{{ $q.version }}</div>
      </q-toolbar>
      <q-separator />
    </q-header>

    <q-drawer v-model="leftDrawerOpen" show-if-above bordered class="bg-white">
      <div class="column items-center">
        <q-img :src="`./img/logo.png`" width="150px" class="q-mx-auto"></q-img>
      </div>

      <q-list>
        <q-expansion-item
          class="cursor-pointer"
          to="/inventory"
          active-class="text-brand"
        >
          <template v-slot:header>
            <q-item-section avatar>
              <q-icon name="inventory_2" />
            </q-item-section>
            <q-item-section>
              <q-item-label>Inventory</q-item-label>
              <q-item-label caption>Manajemen Produk</q-item-label>
            </q-item-section>
          </template>
          <q-item :active="route.name == 'List Inventory'" to="/inventory"
            >List</q-item
          >
          <!-- <q-item :active="route.name == 'Form Inventory'" to="/inventory/form"
            >Form</q-item
          > -->
        </q-expansion-item>
        <q-expansion-item
          class="cursor-pointer"
          to="/inbound"
          active-class="text-brand"
        >
          <template v-slot:header>
            <q-item-section avatar>
              <q-icon name="local_shipping" />
            </q-item-section>
            <q-item-section>
              <q-item-label>Inbound</q-item-label>
              <q-item-label caption>Penerimaan Produk</q-item-label>
            </q-item-section>
          </template>
          <q-item :active="route.name == 'List Inbound'" to="/inbound"
            >List</q-item
          >
          <q-item
            clickable
            :active="route.name == 'Form Inbound'"
            @click="
              data.router_to = '/inbound/Form-Inbound/';
              showDialog('Inbound');
            "
            >Form</q-item
          >
        </q-expansion-item>
        <q-expansion-item
          class="cursor-pointer"
          to="/stok"
          active-class="text-brand"
        >
          <template v-slot:header>
            <q-item-section avatar>
              <q-icon name="warehouse" />
            </q-item-section>
            <q-item-section>
              <q-item-label>Stok</q-item-label>
              <q-item-label caption>Manajemen Stok Produk</q-item-label>
            </q-item-section>
          </template>
          <q-item :active="route.name == 'Riwayat Pergerakan Stok'" to="/stok"
            >Riwayat Pergerakan Stok</q-item
          >
          <q-item
            clickable
            :active="route.name == 'List Penyesuaian Stok'"
            to="/stok/list-penyesuaian-stok"
            >Riwayat Penyesuaian Stok</q-item
          >
          <q-item
            clickable
            :active="route.name == 'Form Retur Gudang'"
            @click="
              data.router_to = '/stok/form-retur-gudang/';
              showDialog('Retur ke Gudang');
            "
            >Form Retur Gudang</q-item
          >
          <q-item
            clickable
            :active="route.name == 'Form Penyesuaian'"
            @click="
              data.router_to = '/stok/form-penyesuaian/';
              showDialog('Penyesuaian Stok');
            "
            >Form Penyesuaian Stok</q-item
          >
          <q-item
            clickable
            :active="route.name == 'Form Retur Customer'"
            @click="
              data.router_to = '/stok/form-retur-customer/';
              showDialog('Retur Customer');
            "
            >Form Retur Customer</q-item
          >
        </q-expansion-item>
        <q-expansion-item
          class="cursor-pointer"
          to="/outbound"
          active-class="text-brand"
        >
          <template v-slot:header>
            <q-item-section avatar>
              <q-icon name="outbox" />
            </q-item-section>
            <q-item-section>
              <q-item-label>List Outbound</q-item-label>
            </q-item-section>
          </template>
          <q-item :active="route.name == 'List Outbound'" to="/outbound"
            >List Outbound</q-item
          >
          <q-item
            clickable
            :active="route.name == 'Scan Outbound'"
            @click="
              data.router_to = '/outbound/scan/';
              showDialog('Scan Outbound');
            "
            >Scan Outbound</q-item
          >
        </q-expansion-item>
        <!-- <q-item
          clickable
          tag="a"
          target="_blank"
          href="https://chat.quasar.dev"
        >
          <q-item-section avatar>
            <q-icon name="warehouse" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Discord Chat Channel</q-item-label>
            <q-item-label caption>chat.quasar.dev</q-item-label>
          </q-item-section>
        </q-item> -->
        <!-- <q-item
          clickable
          tag="a"
          target="_blank"
          href="https://forum.quasar.dev"
        >
          <q-item-section avatar>
            <q-icon name="forum" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Forum</q-item-label>
            <q-item-label caption>forum.quasar.dev</q-item-label>
          </q-item-section>
        </q-item>
        <q-item
          clickable
          tag="a"
          target="_blank"
          href="https://twitter.com/quasarframework"
        >
          <q-item-section avatar>
            <q-icon name="rss_feed" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Twitter</q-item-label>
            <q-item-label caption>@quasarframework</q-item-label>
          </q-item-section>
        </q-item> -->
      </q-list>
    </q-drawer>

    <q-page-container class="my-font" style="background-color: #f4f4f4">
      <router-view class="my-font" />
    </q-page-container>
  </q-layout>
</template>

<script>
import { ref } from "vue";
// import HelloWorld from "./components/HelloWorld.vue";
import InBoundPage from "./components/InBoundPage.vue";
import useBasic from "./composables/useBasic";

import DialogPilihStaff from "./components/DialogPilihStaff.vue";
export default {
  name: "LayoutDefault",
  components: {
    InBoundPage,
  },

  setup() {
    const { route, router, $q, reactive } = useBasic();

    let routes = ref([
      { label: "", desc: "", link: "", is_expanded: false, icon: "" },
    ]);

    let data = reactive({
      router_to: "",
    });

    let showDialog = (process_name) => {
      $q.dialog({
        component: DialogPilihStaff,
        componentProps: {
          process_name: process_name,
        },
      }).onOk((payload) => {
        router.push(`${data.router_to}${payload.id_staff}`);
      });
    };

    return {
      leftDrawerOpen: ref(false),
      route,
      router,
      showDialog,
      data,
    };
  },
};
</script>
<style lang="scss">
@import "@/styles/quasar.scss";
.stickyTable {
  .q-table__top,
  .q-table__bottom,
  thead tr:first-child th {
    background-color: white;
    color: black;
  }
  thead tr th {
    position: sticky;
    z-index: 1;
  }
  thead tr:first-child th {
    top: 0;
  }
  &.q-table--loading thead tr:last-child th {
    top: 48px;
  }
}
.l-container {
  height: 100vh;
}
.l-mobile-container {
  max-width: 1280px;
  min-width: 300px;
  height: calc(100vh - 50px);

  margin: 0 auto;
}
.l-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.l-grow {
  flex-grow: 99;
}

@font-face {
  font-family: barcode;
  src: url(./styles/fonts/barcode.TTF);
}

@font-face {
  font-family: code128;
  src: url(./styles/fonts/code128.ttf);
}

@font-face {
  font-family: customfont;
  src: url(./styles/fonts/Sora-Regular.ttf);
}

@font-face {
  font-family: customfont;
  src: url("./styles/fonts/Sora-Bold.ttf");
  font-weight: 700;
}
@font-face {
  font-family: customfont;
  src: url("./styles/fonts/Sora-SemiBold.ttf");
  font-weight: 500;
}

.barcode-font {
  font-family: "barcode" !important;
}

.barcode-128 {
  font-family: "code128" !important;
}

.my-font {
  font-family: "customfont";
}

.f10 {
  font-size: 10pt;
}
.f12 {
  font-size: 12pt;
}
.f14 {
  font-size: 14pt;
}
.f16 {
  font-size: 16pt;
}
.f18 {
  font-size: 18pt;
}
.f20 {
  font-size: 20pt;
}

.text-bolder {
  font-weight: 900;
}

.bg-brand {
  background: #3d3099 !important;
}

.text-brand {
  color: #3d3099 !important;
}

.l-text-header {
  font-size: 40px !important;
  line-height: 1.8;
  @media only screen and (max-width: 900px) {
    font-size: 36px !important;
  }
  @media only screen and (max-width: 500px) {
    font-size: 24px !important;
  }
}

.l-text-title {
  font-size: 32px !important;
  line-height: 1.8;
  @media only screen and (max-width: 900px) {
    font-size: 26px !important;
  }
  @media only screen and (max-width: 500px) {
    font-size: 20px !important;
  }
}

.l-text-subtitle {
  font-size: 20px !important;
  line-height: 1.8;
  @media only screen and (max-width: 500px) {
    font-size: 16px !important;
  }
}

.l-text-detail {
  font-size: 18px !important;
  line-height: 1.8;
  @media only screen and (max-width: 500px) {
    font-size: 13px !important;
  }
}

.l-text-description {
  font-size: 14px !important;
  line-height: 1.8;
  @media only screen and (max-width: 500px) {
    font-size: 11px !important;
  }
}

.border-card {
  border-radius: 10px !important;
}

.long-text-dots {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.kiri-radius {
  border: 1px solid #bbbbbb;
  border-radius: 8px 0 0 8px !important;
}

.kanan-radius {
  border: 1px solid #bbbbbb;
  border-radius: 0 8px 8px 0 !important;
}
.atas-radius {
  border: 1px solid #bbbbbb;
  border-radius: 8px 8px 0 0 !important;
}
.bawah-radius {
  border: 1px solid #bbbbbb;
  border-radius: 0 0 8px 8px !important;
}

.all-radius {
  border: 1px solid #bbbbbb;
  border-radius: 8px 8px 8px 8px !important;
}
</style>
